import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ERROR_RED_COLOR } from '@/constants/color';

import { Props } from './types';
const IncompleteChecklistItem = ({ text }: Props) => {
  return (
    <div className={ERROR_RED_COLOR} data-testid="incomplete-checklist-item">
      <FontAwesomeIcon icon={faTimesCircle} className="mr-2" data-testid="times-icon" />
      {text}
    </div>
  );
};

export default IncompleteChecklistItem;
